import { MessageCircleIcon, CalendarIcon, SearchIcon, ListChecksIcon, HeartIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type ProcessStep = {
  number: number
  icon: LucideIcon
  title: string
  description: string
}

export const processSteps: ProcessStep[] = [
  {
    number: 1,
    icon: MessageCircleIcon,
    title: 'Escríbenos',
    description: 'Cuéntanos qué necesitas por WhatsApp',
  },
  {
    number: 2,
    icon: CalendarIcon,
    title: 'Agenda tu visita',
    description: 'Coordinamos el horario más cómodo',
  },
  {
    number: 3,
    icon: SearchIcon,
    title: 'Recibe diagnóstico',
    description: 'Te explicamos qué encontramos',
  },
  {
    number: 4,
    icon: ListChecksIcon,
    title: 'Elige tu plan',
    description: 'Decides con información clara',
  },
  {
    number: 5,
    icon: HeartIcon,
    title: 'Inicia con acompañamiento',
    description: 'Te seguimos durante el proceso',
  },
]
